module.exports = "<div class=\"alert alert-info\">\n <i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i>\n <strong>Pracujem</strong>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/util/Spinner.html
// module id = 194
// module chunks = 0